document.addEventListener("DOMContentLoaded", () => {
  const appendedContainer = document.querySelector(".whishlisted_product_container");
  const whishlistCount = document.querySelector("span.whishlist-count");
  const emptyWhishlistcontainer = document.querySelector(".empty__whishlist_page");

  window.whishListedProduct = JSON.parse(localStorage.getItem("whishlistedProduct")) || [];

  if (window.whishListedProduct.length > 0) {
    window.whishListedProduct.forEach(p => {
      appendProductCard(p.handle, p.product);
    });
  }

  const whishlistItems = document.querySelectorAll(".product-wishlist-icon");
  whishlistItems.forEach(item => {
    const productId = item.dataset.product;
    if (window.whishListedProduct.some(p => p.product === productId)) {
      item.classList.add("checked_wishlist_icon");
    }

    item.addEventListener("click", () => {
      const productId = item.dataset.product;
      const productHandle = item.dataset.handle;
      toggleWishlist(productId, productHandle);
    });
  });

  countUpdater();
  emptyHidden();

  function toggleWishlist(productId, handle) {
    const index = window.whishListedProduct.findIndex(p => p.product === productId);

    if (index === -1) {
      window.whishListedProduct.unshift({ product: productId, handle:handle });
      localStorage.setItem("whishlistedProduct", JSON.stringify(window.whishListedProduct));
      appendProductCard(handle, productId);
      document.querySelectorAll(".product-wishlist-icon").forEach(item => {
        if (item.dataset.product == productId) {
          item.classList.add("checked_wishlist_icon");
        }
      });
    } else {
      window.whishListedProduct.splice(index, 1);
      localStorage.setItem("whishlistedProduct", JSON.stringify(window.whishListedProduct));
      removeProductCard(productId);
      document.querySelectorAll(".product-wishlist-icon").forEach(item => {
        if (item.dataset.product == productId) {
          item.classList.remove("checked_wishlist_icon");
        }
      });
    }

    countUpdater();
    emptyHidden();
  }

  function appendProductCard(handle, productId) {
    if (!appendedContainer) return;

    if (document.querySelector(`.wishlist-item[data-product="${productId}"]`)) return;

    fetch(`/products/${handle}?section_id=card-product`)
      .then(res => res.text())
      .then(html => {
        const Item = document.createElement("div");
        Item.className = "wishlist-item";
        Item.setAttribute("data-product", productId);
        Item.innerHTML = html;

        const whishListicon = Item.querySelector(".product-wishlist-icon");
        if (whishListicon) {
          whishListicon.classList.add("checked_wishlist_icon");

          whishListicon.addEventListener("click", () => {
            toggleWishlist(productId, handle);
          });
        }

        appendedContainer.appendChild(Item);
      })
      .catch(console.error);
  }

  function removeProductCard(productId) {
    const item = document.querySelector(`.wishlist-item[data-product="${productId}"]`);
    if (item) item.remove();
  }

  function countUpdater() {
    if (whishlistCount) {
      whishlistCount.textContent = window.whishListedProduct.length;
    }
    if(window.whishListedProduct.length === 0){
      whishlistCount.classList.add("hidden")
    }else{
      whishlistCount.classList.remove("hidden")
    }
  }

  function emptyHidden() {
    if (!emptyWhishlistcontainer) return;
    emptyWhishlistcontainer.classList.toggle('hidden', window.whishListedProduct.length > 0);
    document.body.classList.toggle('empty_wishtlist', window.whishListedProduct.length === 0);

  }
  window.addEventListener("pageshow", () => {
    window.whishListedProduct = JSON.parse(localStorage.getItem("whishlistedProduct")) || [];
    countUpdater();
    emptyHidden();
  });
});
